import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StudentDetails } from 'src/app/models/Search/studentdetails';

@Component({
  selector: 'app-view-student-details',
  templateUrl: './view-student-details.component.html',
  styleUrls: ['./view-student-details.component.scss']
})
export class ViewStudentDetailsComponent {
  constructor(private dialogRef: MatDialogRef<ViewStudentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StudentDetails){
      
    }
    closeDialog(){
      this.dialogRef.close();
    }
}
